import React from 'react';
import ConversionUnlocker from '../components/ConversionUnlocker';

export default function ConversionUnlockerPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="flex justify-between items-center py-8">
            <a href="https://icpedge.com" className="w-48">
              <img 
                src="/logo.png" 
                alt="ICP EDGE Logo" 
                className="w-full h-auto brightness-0 invert"
              />
            </a>
            <a 
              href="https://kronologic.me/1-click/zWxqVT2ASOytpMCtSReRDWxbBRVHiUbHjzqAm5x3Arg"
              className="px-6 py-3 rounded-lg font-semibold bg-white text-blue-600 hover:bg-blue-50 transition-colors"
            >
              Partner With Us
            </a>
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4 max-w-6xl py-12">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose prose-lg max-w-none mb-12">
            <h1 className="text-3xl font-bold mb-4">Conversion Unlocker</h1>
            <p className="text-gray-600">
              Identify and eliminate hidden conversion blockers preventing your customers from taking action. This diagnostic tool helps uncover the specific mental blocks and decision barriers affecting your conversion rates.
            </p>
          </div>

          <ConversionUnlocker />
        </div>
      </div>
    </div>
  );
}